module.exports = __webpack_public_path__ + "static/media/pic2@3x.97a19fe0.png";